import React from 'react'
import s from './GeoentityBlockLink.less'
import SVGIcon from '../../svg/SVGIcon'
import { SPD_GEOENTITY_LINK } from '../../analytics/BiTagger'
import useTagBiForGeoentity from '../useTagBiForGeoentity'
import useCommonGeoentityClickTagProps from '../useCommonGeoentityClickTagProps'
import { PUB_TAG } from '../../analytics/PublisherTagsService'
import TagActionLink from '../../genericComponents/TagActionLink'
import { getComponentOrClassNameByGeoentityBlockAspect } from './GeoentityBlockUtils'
import RectangleActionButton, {
  COLOR_GREY_EMPTY,
  COLOR_ORANGE_EMPTY
} from '../../genericComponents/buttons/RectangleActionButton'

export default function GeoentityBlockLink(props) {
  const { data = {} } = props
  const { aspect, templatizedUrl, label, tag } = data
  const clickTagProps = useCommonGeoentityClickTagProps(PUB_TAG.PUB_FICHEPOI_REDIRECTIONRESERVATION)
  const sendBiTagNow = useTagBiForGeoentity(tag ?? SPD_GEOENTITY_LINK, { targeturl: templatizedUrl })

  if (!templatizedUrl || !label) return null

  const className = getComponentOrClassNameByGeoentityBlockAspect(
    {
      link: s.link,
      button: s.button,
      light_button: s.button,
      title: s.title
    },
    data
  )

  if (!className) return null

  const buttonColor = aspect === 'light_button' ? COLOR_GREY_EMPTY : COLOR_ORANGE_EMPTY

  return (
    <div className={className}>
      {aspect === 'button' || aspect === 'light_button' ? (
        <RectangleActionButton
          color={buttonColor}
          href={templatizedUrl}
          targetBlank={true}
          nofollow={true}
          onClick={() => {
            sendBiTagNow()
          }}
          tagData={clickTagProps}
          label={label}
        />
      ) : (
        <TagActionLink
          href={templatizedUrl}
          targetBlank={true}
          nofollow={true}
          onClick={() => {
            sendBiTagNow()
          }}
          {...clickTagProps}
        >
          {label}
        </TagActionLink>
      )}
      {aspect === 'link' && (
        <span className={s.linkArrow}>
          <SVGIcon icon={'chevron'} />
        </span>
      )}
    </div>
  )
}
